export function parseRetryAfter(headers: unknown): number | undefined {
  const raw = (headers as Record<string, string> | undefined)?.['retry-after']?.trim();
  if (!raw) return undefined;
  if (/^\d+$/.test(raw)) return parseInt(raw, 10);
  const dateMs = Date.parse(raw);
  return Number.isNaN(dateMs) ? undefined : Math.max(0, Math.ceil((dateMs - Date.now()) / 1000));
}
